import { getOr } from 'lodash/fp';

export const getOrFalse = getOr(false);
